// Utilities for generating the shipment code

export const sanitizeShortCode = (raw) => {
  if (!raw) return "";
  // Strip everything non-alphanumeric, then uppercase
  return raw.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
};

export const getDDMM = (date = new Date()) => {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  return `${dd}${mm}`;
};

// Reef China Warehouse → code prefix (inserted after DA/DS)
export const WAREHOUSE_CODE_MAP = {
  YIWU: "YW",
};

/**
 * Build code: [DA/DS]-[WAREHOUSE_CODE?]-[T?]-[B?]-[W?]-[BB?]-[M?]-RF-[ShortCode(+seq?)]-[DDMM]
 */
export const buildShipmentCode = ({
  shipmentMode,
  hasDgBattery,
  hasBrand,
  shortCode,
  pickup,
  warehouseLocation,
  isWooden,
  isProteinSupplement,
  isMedical,
  seq,
}) => {
  const parts = [];

  if (shipmentMode === "AIR") parts.push("DA");
  else if (shipmentMode === "SEA") parts.push("DS");

  // Warehouse code only when picking up from Reef China Warehouse
  if (parts.length > 0 && pickup === "reef_warehouse" && warehouseLocation) {
    const wcode = WAREHOUSE_CODE_MAP[String(warehouseLocation).trim().toUpperCase()];
    if (wcode) parts.push(wcode);
  }

  if (hasDgBattery === true) parts.push("T");
  if (hasBrand === true) parts.push("B");
  if (isWooden === true) parts.push("W");
  if (isProteinSupplement === true) parts.push("BB");
  if (isMedical === true) parts.push("M");

  if (parts.length > 0) parts.push("RF");

  let clean = sanitizeShortCode(shortCode);
  if (clean) {
    if (seq && Number(seq) > 0) {
      clean = `${clean}${Number(seq)}`;
    }
    parts.push(clean);
  }

  if (parts.length > 0) parts.push(getDDMM());

  return parts.join("-");
};
